module.exports = __webpack_public_path__ + "img/sense-imatge.d7383093.jpg";